interface MeddraCateTreeIconProps {
    level: number,
    isForward?: boolean,
    bordered?: boolean
}

import { ReactComponent as Llt } from '@/assets/icons/llt.svg'
import { ReactComponent as Pt } from '@/assets/icons/pt.svg'
import { ReactComponent as Hlt } from '@/assets/icons/hlt.svg'
import { ReactComponent as Hlgt } from '@/assets/icons/hlgt.svg'
import { ReactComponent as Soc } from '@/assets/icons/soc.svg'

import styles from './index.module.less'
/**
 * @param param0 cate层级
 * @returns 需要渲染对应层级的icon
 */
/**
 * 
 * @param level 当前节点层级
 * @param isForward 是否是正序 true 正序 false 倒序
 * @param bordered 图标展示方框
 * @returns 
 */
const MeddraCateTreeIcon = ({level, isForward = true, bordered = false}: MeddraCateTreeIconProps)=>{
    if (!isForward) {
        // 层级树由内向外展开
        if (level === 1) return <Llt />
        if (level === 2) return <Pt />
        if (level === 3) return <Hlt />
        if (level === 4) return <Hlgt />
        if (level === 5) return bordered ? <span className={styles.meddra_cate_tree_icon_box}><Soc /></span> : <Soc />
        return null
    }

    if (level === 1) return bordered ? <span className={styles.meddra_cate_tree_icon_box}><Soc /></span> : <Soc />
    if (level === 2) return <Hlgt />
    if (level === 3) return <Hlt />
    if (level === 4) return <Pt />
    if (level === 5) return <Llt />

    return null
}

export default MeddraCateTreeIcon